export default {
  data() {},
  methods: {
    getType(type) {
      switch (type) {
        case '01': {
          return 'INVOICE'
        }
        case '02': {
          return 'CREDIT NOTE'
        }
        case '03': {
          return 'DEBIT NOTE'
        }
        case '04': {
          return 'REFUND NOTE'
        }
        case '11': {
          return 'SELF-BILLED INVOICE'
        }
        case '12': {
          return 'SELF-BILLED CREDIT NOTE'
        }
        case '13': {
          return 'SELF-BILLED DEBIT NOTE'
        }
        case '14': {
          return 'SELF-BILLED REFUND NOTE'
        }
      }
    },
  },
}
